export const data = [
  {
    id: 1,
    user: "Punit",
    Organization: "Rainbow Mumbai Hospitals",
    Email: "Punit+care.provider+6@unify.digital",
    userDesc: "@Punit",
    status: "Active",
    Roles: ["Doctor HOD"],
    Updated: "Mar 14, 2024 12:34 PM",
  },
  {
    id: 2,
    user: "Dipanhsu",
    Organization: "Rainbow Mumbai Hospitals",
    userDesc: "@Dipanhsu",
    Email: "Dipanhsu+care.provider+6@unify.digital",
    status: "Pending",
    Roles: "Nurse",
    Updated: "Mar 14, 2024 12:34 PM",
  },
  {
    id: 3,
    user: "Mohan",
    Organization: "--",
    userDesc: "@mohan",
    Email: "mohan+care.provider+6@unify.digital",
    status: "Active",
    Roles: "Admin",
    Updated: "Mar 14, 2024 12:34 PM",
  },
  {
    id: 4,
    user: "Dora Sai Teja",
    Organization: "Rainbow Mumbai Hospitals",
    userDesc: "@Dora Sai Tejal",
    Email: "DoraSaiTeja+care.provider+6@unify.digital",
    status: "Active",
    Roles: "Doctor",
    Updated: "Mar 14, 2024 12:34 PM",
  },
];

// export const UserFrom = {
//   UserBasicInfo: [
//     {
//       type: "text",
//       label: "Organization",
//       id: "organization",
//       placeholder: "Select Organization",
//     },
//     {
//       type: "text",
//       label: "Email",
//       id: "Email",
//       placeholder: "Email",
//     },
//     {
//       type: "dropdown",
//       label: "Phone Number",
//       id: "PNumber",
//       placeholder: "Enter your Number",
//     },
//     {
//       type: "text",
//       label: "First Name",
//       id: "FirstName",
//       placeholder: "First Name",
//     },
//     {
//       type: "text",
//       label: "Last Name",
//       id: "LastName",
//       placeholder: "Last Name",
//     },
//     {
//       type: "text",
//       label: "Gender",
//       id: "gender",
//       placeholder: "Gender",
//       options: ["Male", "Female"],
//     },
//     {
//       type: "dropdown",
//       label: "User Profile",
//       id: "Profile",
//       placeholder: "User Profile",
//       options: ["Admin", "Doctor", "Nurse", "Staff"],
//     },
//   ],
// };

export const UserFrom = {
  PersonalData: [
    {
      forminput: [
        {
          type: "file",
          label: "Upload image",
          id: "imageUrl",
          placeholder: "Upload",
        },
        {
          type: "text",
          label: "First Name",
          id: "firstName",
          placeholder: "First Name",
          required: true,
        },
        {
          type: "text",
          label: "Last Name",
          id: "lastName",
          placeholder: "Last Name",
          required: true,
        },
        {
          type: "date",
          label: "Date of Birth",
          id: "dateOfBirth",
          placeholder: "DD-MM-YYYY",
          required: true,
        },
        {
          type: "select",
          label: "Gender",
          id: "gender",
          placeholder: "Select gender",
          required: true,
          options: ["Male", "Female", "Other"],
        },
        {
          type: "tel",
          label: "Phone Number",
          id: "phoneNumber",
          required: true,
          placeholder: "Enter your phone number",
        },
        {
          type: "email",
          label: "Email",
          id: "email",
          required: true,
          placeholder: "Email",
        },
      ],
    },
  ],
  ContactData: [
    {
      forminput: [
        {
          type: "text",
          label: "Address 1 ",
          required: true,
          id: "Address1",
          placeholder: "Address 1",
        },
        {
          type: "text",
          label: "Address 2",
          id: "Address2",
          placeholder: "Address 2",
        },
        {
          type: "text",
          label: "Country ",
          required: true,
          id: "country",
          placeholder: "Country",
        },
        {
          type: "text",
          label: "State ",
          required: true,
          id: "state",
          placeholder: "State",
        },
        {
          type: "text",
          label: "City ",
          required: true,
          id: "city",
          placeholder: "City",
        },
        {
          type: "number",
          label: "Zipcode ",
          required: true,
          id: "zipCode",
          placeholder: "zipCode",
        },
      ],
    },
  ],
  WorkData: [
    {
      forminput: [
        {
          type: "text",
          label: "Designation ",
          required: true,
          id: "designation",
          placeholder: "Designation",
        },
        {
          type: "text",
          label: "Speciality ",
          required: true,
          id: "speciality",
          placeholder: "Speciality",
        },
        {
          type: "number",
          label: "Experience (in months) ",
          required: true,
          id: "experience",
          placeholder: "Experience",
        },
        {
          type: "text",
          label: "License Number ",
          required: true,
          id: "licenseNumber",
          placeholder: "License Number",
        },
        {
          type: "text",
          label: "HPR Id",
          id: "hprId",
          placeholder: "HPR Id",
        },
        {
          type: "text",
          label: "Re-enter HPR Id",
          id: "reenterHprId",
          placeholder: "Re-enter HPR Id",
        },
        {
          type: "text",
          label: "Qualification ",
          required: true,
          id: "qualification",
          placeholder: "qualification",
        },
        {
          type: "text",
          label: "Consultation Prices(Online)  ",
          required: true,
          id: "online",
          placeholder: "Online",
        },
        {
          type: "text",
          label: "Consultation Prices(InPerson)  ",
          required: true,
          id: "inPerson",
          placeholder: "InPerson",
        },
        {
          type: "textarea",
          label: "About Doctor ",
          required: true,
          id: "about",
          placeholder: "About Doctor",
        },
      ],
    },
  ],
  ServiceData: [
    {
      heading: "+ Services",
      subHeading: "+ Add Services",
      forminput: [
        {
          type: "textarea",
          label: "Teriffs ",
          required: true,
          id: "teriffs",
          placeholder: "Teriffs",
        },
        {
          type: "text",
          label: "Grace Period ",
          required: true,
          id: "gracePeriod",
          placeholder: "Days",
        },
        {
          type: "text",
          label: "Max Free Appointments ",
          required: true,
          id: "maxFreeAppointments",
          placeholder: "1",
        },
        {
          type: "text",
          label: "Assistance ",
          required: true,
          id: "assistance",
          placeholder: "Search By Name",
        },
      ],
    },
  ],
  RosterData: [
    {
      forminput: [
        {
          type: "text",
          label: "Name *",
          id: "Name",
          placeholder: "Name",
        },
        {
          type: "text",
          label: "Email *",
          id: "Email",
          placeholder: "Email",
        },
      ],
    },
  ],
};
